import { render, staticRenderFns } from "./VehiculePhotosForm.vue?vue&type=template&id=8d81cddc&scoped=true&"
import script from "./VehiculePhotosForm.vue?vue&type=script&lang=js&"
export * from "./VehiculePhotosForm.vue?vue&type=script&lang=js&"
import style0 from "./VehiculePhotosForm.vue?vue&type=style&index=0&id=8d81cddc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d81cddc",
  null
  
)

export default component.exports